import React, { useContext } from 'react';
import TemplateAddEditView from '../modules/templates/addEditView/index';
import { Routes, Route, Navigate } from 'react-router-dom';
import {
    AuthRoutes,
    RouteParamsTypes,
    Modules,
    NonAuthRoutes,
    PermissionModulesEnum,
    PermissionActionsEnum,
} from '../enums';
import { MenuTextMapping } from '../utils/appConstant';
import { redirectBasedOnPermission } from '../utils/methods';
import { AuthContext } from '../contexts/AuthContext';
import ProtectedRoute from '../components/ProtectedRoute';
import TemplateList from '../modules/templates/list';

const Templates: React.FC = () => {
    const { isSystemAdmin, permissions } = useContext(AuthContext);
    return (
        <Routes>
            <Route path={AuthRoutes.templates}>
                <Route
                    path={AuthRoutes.templates + RouteParamsTypes.blank}
                    element={
                        <ProtectedRoute
                            component={TemplateList}
                            accessibleTo={[{ [PermissionModulesEnum.Templates]: [PermissionActionsEnum.View] }]}
                        />
                    }
                />
                <Route
                    path={AuthRoutes.templates + RouteParamsTypes.add}
                    element={
                        <ProtectedRoute
                            component={TemplateAddEditView}
                            accessibleTo={[{ [PermissionModulesEnum.Templates]: [PermissionActionsEnum.Add] }]}
                        />
                    }
                />
                <Route
                    path={AuthRoutes.templates + RouteParamsTypes.edit + RouteParamsTypes.id}
                    element={
                        <ProtectedRoute
                            component={TemplateAddEditView}
                            accessibleTo={[{ [PermissionModulesEnum.Templates]: [PermissionActionsEnum.Update] }]}
                        />
                    }
                />
                <Route
                    path={AuthRoutes.templates + RouteParamsTypes.view + RouteParamsTypes.id}
                    element={
                        <ProtectedRoute
                            component={TemplateAddEditView}
                            accessibleTo={[{ [PermissionModulesEnum.Templates]: [PermissionActionsEnum.View] }]}
                        />
                    }
                />
            </Route>

            <Route
                path={RouteParamsTypes.blank}
                element={
                    <Navigate
                        replace
                        to={{
                            pathname:
                                redirectBasedOnPermission(isSystemAdmin, permissions, MenuTextMapping.templates) ||
                                Modules.error + NonAuthRoutes.forbidden,
                        }}
                    />
                }
            />
            <Route
                path={RouteParamsTypes.any}
                element={<Navigate replace to={{ pathname: Modules.error + NonAuthRoutes.notFound }} />}
            />
        </Routes>
    );
};

export default Templates;
